import React from "react";
import ReactMarkdown from "react-markdown";
import { Typography, Box, Button } from "@material-ui/core";

const Content = ({ title = null, text = null, onClose, isMobile }) => {
  if (!text || !title) {
    return null;
  }
  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Typography variant="body1" component="div">
        <ReactMarkdown linkTarget="_blank">{text}</ReactMarkdown>
      </Typography>
      <Box py={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          fullWidth={isMobile}
          size="large"
        >
          Schließen
        </Button>
      </Box>
    </>
  );
};

export default Content;
